module.exports = __webpack_public_path__ + "img/UM.b8d2fa02.png";